"use client";
import Image from "next/image";
import Button from "@/shared/Buttons/Button";
import styles from "./not-found.module.css";

export default function NotFound() {
	const handleGoHome = () => {
		window.location.href = "/";
	};

	return (
		<div className={styles.notFoundContainer}>
			<div className={styles.content}>
				<Image
					src="/icons/404.svg"
					alt="Page not found"
					width={378}
					height={208}
					className={styles.notFoundImage}
				/>
				<p className={styles.description}>
					Мы искали, но не нашли… Кажется, эта страница исчезла!
				</p>
			</div>
			<div className={styles.buttonWrapper}>
				<Button
					text="Вернуться на главную"
					onClick={handleGoHome}
					variant="default"
					color="dark"
					size="md"
				/>
			</div>
		</div>
	);
}
